import { Component, inject, OnInit, ViewChild } from '@angular/core';

import { TwoColumnLayoutComponent } from '@layouts/sections/two-column-layout/two-column-layout.component';
import { ProductionGameRankComponent } from '../production-game-rank/production-game-rank.component';
import { ProductionGameRateComponent } from '../production-game-rate/production-game-rate.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { SlidingTwoColumnLayoutComponent } from '@layouts/sections/sliding-two-column-layout/sliding-two-column-layout.component';
import { ProductionGamePageService } from '@features/games/services/production-game-page.service';
import { GameRankingService } from '@features/games/services/game-ranking.service';

@Component({
  selector: 'app-production-game-play',
  imports: [CommonModule, ProductionGameRankComponent, ProductionGameRateComponent, SlidingTwoColumnLayoutComponent],
  templateUrl: './production-game-play.component.html',
  styleUrl: './production-game-play.component.scss'
})
export class ProductionGamePlayComponent implements OnInit {

  @ViewChild('slidingTwoColumnLayout') layoutComponent!: SlidingTwoColumnLayoutComponent;
  @ViewChild('ranking') rankingComponent!: ProductionGameRankComponent;

  private breakpointObserver = inject(BreakpointObserver);
  private productionGamePageService = inject(ProductionGamePageService);
  private gameRankingService = inject(GameRankingService);

  public isHandset: boolean = false;
  public isLeftPanelOpen: boolean = true;
  public autoMove: boolean = true;
  private gameDetailsId?: string;

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => { 
      this.isHandset = state.matches; 
    }); 
      
    this.breakpointObserver .observe([ Breakpoints.Tablet, Breakpoints.Web, Breakpoints.WebLandscape ]).subscribe((state: BreakpointState) => { 
      this.isHandset = !state.matches; 
    });

    this.productionGamePageService.page$.subscribe(page => {
      if (!page?.gameDetails?.id) return;
 
      this.gameDetailsId = page.gameDetails!.id;
    });
  }

  public onAutoMoveChange(event: any) {
    this.autoMove = event.checked;
    this.rankingComponent.autoMove = this.autoMove;
  }

  public toggleLeftPanel() {
    this.layoutComponent.toggleLeftPanel();
    this.isLeftPanelOpen = false;
  }

  public reset() {
    if (!this.gameDetailsId) return;

    this.gameRankingService.resetRankingList({ gameDetailsId: this.gameDetailsId }).subscribe(result => {
      this.rankingComponent.resetRankings();
    });
  }
}
